/*
 * Re-renders a section when the shopper switches variant.
 *
 * Sections outside <product-info> are untouched by product-info.js, which only swaps markup
 * within itself. This listens for the variantChange event that product-info.js publishes and
 * refetches its own section through the Section Rendering API, scoped to the new variant, so
 * variant-specific content stays in step with the rest of the page.
 */
if (!customElements.get('variant-section')) {
  customElements.define(
    'variant-section',
    class VariantSection extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.productUrl || !this.dataset.sectionId) return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.abortController?.abort();
      }

      onVariantChange({ data }) {
        const variantId = data?.variant?.id;
        // no variant means the selected combination is unavailable; leave the current content
        if (!variantId || String(variantId) === this.dataset.variantId) return;
        this.dataset.variantId = String(variantId);

        // a shopper clicking through options fires these faster than they resolve
        this.abortController?.abort();
        this.abortController = new AbortController();

        const url = `${this.dataset.productUrl}?variant=${variantId}&section_id=${this.dataset.sectionId}`;

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((text) => {
            const incoming = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector(`variant-section[data-section-id="${this.dataset.sectionId}"]`);
            if (!incoming) return;
            // the reveal animation has already played, so suppress it on the swapped-in markup
            incoming
              .querySelectorAll('.scroll-trigger')
              .forEach((element) => element.classList.add('scroll-trigger--cancel'));
            this.innerHTML = incoming.innerHTML;
            this.dispatchEvent(new CustomEvent('variant-section:updated', { bubbles: true }));
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }
    }
  );
}
